import React from 'react';
import { createRoot } from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';

import { CartProvider } from '@zooplus/cart-provider';
import { Domain, findSiteByDomain, Locale, SiteProvider } from '@zooplus/commons-lang';

import { ENV } from '../../environment';
import { initializeI18n } from '../../services/i18n-service';
import FallbackComponent from '../ErrorFallback';
import SentryErrorBoundary from '../SentryErrorBoundary';

import { OwnBrands } from './OwnBrand';

const wrapper = document.getElementById('own-brands-wrapper') as HTMLElement;
if (wrapper) {
  const locale = (wrapper.getAttribute('data-locale')! ?? '').replace('_', '-') as Locale;
  const redirectPath =
    locale === ('fr-CH' as Locale) ? '/fr/info/ob/own-brands' : '/info/ob/own-brands';
  const redirectUrl = `${redirectPath}${window.location.search}${window.location.hash}`;

  if (
    `${window.location.pathname}${window.location.search}${window.location.hash}` !== redirectUrl
  ) {
    window.location.replace(redirectUrl);
  } else {
    const siteDomain = (wrapper.getAttribute('data-site-domain') ?? '') as Domain;
    renderCentralHub(wrapper, siteDomain, locale);
  }
}

function renderCentralHub(element: HTMLElement, siteDomain: Domain, locale: Locale) {
  const site = findSiteByDomain(siteDomain);
  const root = createRoot(element);
  root.render(
    <React.StrictMode>
      <SentryErrorBoundary FallbackComponent={FallbackComponent}>
        <I18nextProvider i18n={initializeI18n(locale)}>
          <SiteProvider locale={locale} site={site}>
            <CartProvider stage={ENV.stage} cartVersion={'v1'}>
              <OwnBrands />
            </CartProvider>
          </SiteProvider>
        </I18nextProvider>
      </SentryErrorBoundary>
    </React.StrictMode>,
  );
}
